import React from 'react';
import MethodsTwoContext from '../Contexts/MethodsTwo';
import axios from '../Api/MainApi';
import logger from '../Tools/Log';
import Sticky from 'react-stickynode';
import CommentModule from '../Components/Comment';
import { Link } from 'react-router-dom';


export default class App extends React.Component {
  constructor(props) {
    super(props);
    if (!this.state.firstLoad) {
      this.state = {
        content: "",
        urlId: this.props.match.params.id,
        topicId: 0,
        userId: '',
        topics:[]
      }
    }
  }

  state = {
    content: "",
    urlId: "",
    topicId: 0,
    userId: '',
    topics:[]
  }


  static contextType = MethodsTwoContext;

  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
    this.getContentFromServer(this.state.urlId);
    this.getAllTopics();
  }
  

  // componentDidUpdate(){
  //   if(this.state.urlId !=  this.props.match.params.id){
  //     this.state.urlId = this.props.match.params.id;
  //     this.getContentFromServer(this.state.urlId);
  //   }  
  // }

  getAllTopics(){
    axios.get(`rest/GetAllTopic`)
    .then(Response => {
      console.log(Response.data)
      this.setState({topics:Response.data});
    })
    .catch(err => {
      console.log(err)
    })
  }

  getContentFromServer(text) {
    axios.get(`rest/GetPageContentByUrl/${text}`)
      .then(Response => {
        this.setState({
          content: Response.data.value,
          topicId: Response.data.topicId
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  render() {
    return (
      <>
        <div class="header_section">
          <div class="container">
            <div class="grid grid-cols-12 gap-1" >
              <div class="page-main col-span-12 mx-4 md:mx-0 md:col-start-1 md:col-span-9 mt-14 ">
                <div class="under-text style-02 px-2 md:px-6 mb-4">
                  <div class="maz_fulltext swin_text py-16">
                    <div dangerouslySetInnerHTML={{ __html: this.state.content }} />
                  </div>
                </div>
                <div class=" style-02 under-text p-3 mb-8">
                  <div class="maz_fulltext swin_text pt-10 ">
                    <CommentModule topicId={this.state.topicId} userId={this.state.userId} />
                  </div>
                </div>
              </div>
              <div class="hide-in-mobile md:col-start-10 md:col-span-3 md:mx-4 mt-14 ">
                <Sticky enabled={true} top={0} bottomBoundary={3000}>
                        {this.state.topics.map((e, key) => {
                          return (<>{e.active ? 
                            <a href={'/articles/' + e.pageurl}> 
                              <div class='p-4 bg-white hover:bg-gray-200 border-gray-200 border-solid border leading-5 shadow-md mb-1'>
                                  <h3 class='mb-2 font-bold'>{e.titleone}</h3>
                                  <p class='font-thin'>{e.titletwo}</p>
                              </div>
                            </a>
                            : <></>}
                            </>)
                        })}
                </Sticky>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}


